import styled, { css } from 'styled-components';
import { ContentWrapper, FlexColumn } from './common';
import { Breakpoints, FontWeight } from './constants';
import { StyledSearchContainer } from '../components/ui/Input/styled';

export const PageWrapper = styled(ContentWrapper)`
  flex-direction: column;

  h1 {
    font-size: 16px;
    font-weight: ${FontWeight.medium};
  }

  @media screen and (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    padding: 20px 0;
  }

  #page_header {
    @media screen and (min-width: ${Breakpoints.tablet}px) {
      display: none;
    }
  }

  @media screen and (min-width: 1439px) {
    min-width: ${Breakpoints.desktop}px;
  }

  .fallback-view {
    margin: auto;
  }
`;

export const DesktopPageHeader = styled(FlexColumn)<{
  $isResidencePage: boolean;
  $direction: 'column' | 'row';
  $showDesktopTitle: boolean;
}>`
  align-items: flex-start;
  gap: 20px;
  padding: ${({ $showDesktopTitle }) => ($showDesktopTitle ? '15px' : 0)};
  flex-direction: ${({ $direction }) => $direction || 'column'};

  > .search-container,
  input {
    height: 50px;
    background-color: inherit;
    width: 100%;

    &:focus {
      font-size: 16px;
    }
  }

  .search-container:has(input:focus) {
    border-color: ${({ theme }) => theme.colors.systemColors.blue};
  }

  h1 {
    font-size: 16px;
    font-weight: ${FontWeight.bold};

    @media screen and (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
      display: none;
    }
  }

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    margin-bottom: 30px;
    padding: 0;
  }

  @media screen and (min-width: ${Breakpoints.desktop}px) {
    flex-direction: row;
    align-items: center;
    gap: ${({ $isResidencePage }) => ($isResidencePage ? '40px' : '70px')};

    ${({ $isResidencePage }) =>
      !$isResidencePage &&
      css`
        > div,
        input {
          max-width: 480px;
        }
      `};

    ${({ $isResidencePage }) =>
      $isResidencePage &&
      css`
        justify-content: space-between;

        ${StyledSearchContainer},
        input {
          max-width: 340px;
        }
      `};
  }
`;
